import { createGlobalStyle } from 'styled-components';
import fontsCss from './fonts.css';

export default createGlobalStyle`
  ${fontsCss}
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Google Sans', Helvetica, Arial, sans-serif;
    font-feature-settings: 'locl' 1;

    #onetrust-banner-sdk {
      outline: 0;
    }
  }

  input, textarea, select, button {
    font-family: inherit;
    font-feature-settings: inherit;
  }

  html[lang^='bg'] body,
  html[lang^='bg'] * {
    font-family: 'Noto Sans', 'Segoe UI', Arial, sans-serif;
  }

  #root {
    margin: 0 auto;
  }

  a, button {
    background-color: unset;
    border: 0;
    cursor: pointer;
    text-decoration: none;
  }
`;
